/* Galerie produit : chargement des images masquées + zoom plein écran défilable.
   Complète theme.js : prend en charge le bouton « Zoom » (capture du clic). */
(function () {
  'use strict';
  if (window.__caLightbox) return;
  window.__caLightbox = true;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Images des diapositives masquées ----------
     Les images « lazy » placées dans une diapositive display:none ne se
     chargeaient qu'à l'affichage : écran vide à chaque changement d'image. */
  function eagerAll() {
    qsa('[data-gallery-slide] img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
  }
  function markSingle() {
    qsa('[data-gallery]').forEach(function (g) {
      if (!g.querySelector('.gallery__thumbs')) g.classList.add('gallery--single');
    });
  }
  function boot() {
    markSingle();
    setTimeout(eagerAll, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  /* ---------- Zoom plein écran ---------- */
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';

  var box, stage, img, counter;
  var items = [], pos = 0, gallery = null, lastFocus = null, swipedAt = 0;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'ca-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.tabIndex = -1;
    box.innerHTML =
      '<button type="button" class="ca-lightbox__btn ca-lightbox__close" aria-label="Fermer">' + ICON_CLOSE + '</button>' +
      '<button type="button" class="ca-lightbox__btn ca-lightbox__prev" aria-label="Image précédente">' + ICON_PREV + '</button>' +
      '<button type="button" class="ca-lightbox__btn ca-lightbox__next" aria-label="Image suivante">' + ICON_NEXT + '</button>' +
      '<div class="ca-lightbox__stage"><img class="ca-lightbox__img" alt="" draggable="false"></div>' +
      '<div class="ca-lightbox__counter" aria-live="polite"></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.ca-lightbox__stage');
    img = box.querySelector('.ca-lightbox__img');
    counter = box.querySelector('.ca-lightbox__counter');

    box.querySelector('.ca-lightbox__close').addEventListener('click', close);
    box.querySelector('.ca-lightbox__prev').addEventListener('click', function () { go(-1); });
    box.querySelector('.ca-lightbox__next').addEventListener('click', function () { go(1); });

    /* Clic sur le fond = fermer (sauf juste après un glissement). */
    box.addEventListener('click', function (e) {
      if (Date.now() - swipedAt < 400) return;
      if (e.target === box || e.target === stage) close();
    });

    /* Glissement tactile ou souris. */
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      tracking = true; sx = e.clientX; sy = e.clientY;
    });
    function end(e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) {
        swipedAt = Date.now();
        go(dx < 0 ? 1 : -1);
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', function () { tracking = false; });
  }

  function activeIndex(g) {
    var slides = qsa('[data-gallery-slide]', g);
    for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
    return 0;
  }

  function render() {
    var it = items[pos];
    img.classList.remove('is-ready');
    img.onload = function () { img.classList.add('is-ready'); };
    img.onerror = function () { img.classList.add('is-ready'); };
    img.alt = it.alt;
    img.src = it.src;
    if (img.complete && img.naturalWidth) img.classList.add('is-ready');
    counter.textContent = (pos + 1) + ' / ' + items.length;
    /* Précharge les voisines pour un défilement sans attente. */
    [1, -1].forEach(function (d) {
      if (items.length < 2) return;
      var n = items[(pos + d + items.length) % items.length];
      new Image().src = n.src;
    });
  }

  function go(d) {
    if (items.length < 2) return;
    pos = (pos + d + items.length) % items.length;
    render();
  }

  function open(g, startIndex) {
    var slides = qsa('[data-gallery-slide]', g);
    items = [];
    slides.forEach(function (s, k) {
      var im = s.querySelector('img[data-zoom-src]');
      if (im) items.push({ idx: k, src: im.getAttribute('data-zoom-src'), alt: im.getAttribute('alt') || '' });
    });
    if (!items.length) return;
    gallery = g;
    pos = 0;
    items.forEach(function (it, i) { if (it.idx === startIndex) pos = i; });
    build();
    box.classList.toggle('is-single', items.length < 2);
    box.classList.add('is-open');
    document.documentElement.classList.add('body-lock');
    document.body.classList.add('body-lock');
    lastFocus = document.activeElement;
    render();
    box.focus();
  }

  function close() {
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('body-lock');
    document.body.classList.remove('body-lock');
    if (gallery && typeof gallery.showIndex === 'function' && items[pos]) gallery.showIndex(items[pos].idx);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* ignoré */ } }
  }

  /* Phase de capture : on passe avant l'ancien gestionnaire de theme.js. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var zoomBtn = t.closest('[data-gallery-zoom]');
    if (zoomBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var g = zoomBtn.closest('[data-gallery]');
      if (g) open(g, activeIndex(g));
      return;
    }
    var pic = t.closest('.gallery__slide img[data-zoom-src]');
    if (pic) {
      var g2 = pic.closest('[data-gallery]');
      if (g2 && g2.querySelector('[data-gallery-zoom]')) open(g2, activeIndex(g2));
      return;
    }
    if (t.closest('[data-gallery]')) eagerAll();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
  });
})();
